var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sticky-element-container"},[_c('div',{class:[_vm.stickyContainer ? 'sticky-container' : '', 'element-wrapper']},[_c('div',{staticClass:"element"},[_vm._t("element")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }